import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { uniqueId } from 'lodash';
import { getComponentBasicInfo, getComponentVariables } from '@/services/execComponentService';
import { convertDetailToProps } from '@/pages/Maintenance/Template/Variables/components/VarInput';

const initialState = {
  currentEnv: {},
  currentCluster: {},
  basicInfo: {},
  currentHosts: [], // 选中的主机
  currentLib: null,
  defaultVariables: [],
  defaultIpVariables: [],
  currentVariables: [],
  currentIpVariables: [],
  deployedHosts: [], // 已经部署过的主机
  operate: null,
};

export const fetchComponentBasicInfo = createAsyncThunk(
  'execComponent/fetchComponentBasicInfo',
  async (params) => {
    const response = await getComponentBasicInfo(params);
    return response.data;
  },
);

export const fetchComponentVariables = createAsyncThunk(
  'execComponent/fetchComponentVariables',
  async (params) => {
    const response = await getComponentVariables(params);
    return response.data;
  },
);

export const execComponentSlice = createSlice({
  name: 'execComponent',
  initialState,
  reducers: {
    setCurrentEnv: (state, action) => {
      state.currentEnv = action.payload;
    },
    setCurrentCluster: (state, action) => {
      state.currentCluster = action.payload;
    },
    setComponentCurrentHosts: (state, action) => {
      state.currentHosts = action.payload;
    },
    setComponentVariables: (state, action) => {
      state.currentVariables = action.payload;
    },
    setComponentIpVariables: (state, action) => {
      state.currentIpVariables = action.payload;
    },
    removeComponentVariables: (state, action) => {
      state.currentVariables = state.currentVariables.filter((item) => item.id !== action.payload);
    },
    // 根据变量scriptStencilVariableId剔除
    removeComponentIpVariables: (state, action) => {
      state.currentIpVariables = state.currentIpVariables.filter(
        (item) => item.scriptStencilVariableId !== action.payload,
      );
    },
    modifyHosts: (state, action) => {
      state.currentHosts = action.payload;
    },
    removeComponentHost: (state, action) => {
      const id = action.payload;
      state.currentHosts = state.currentHosts.filter((item) => item.id !== id);
      // 同步剔除变量
      state.currentIpVariables = state.currentIpVariables.filter((item) => item.ip !== id);
    },
    setComponentCurrentLib: (state, action) => {
      state.currentLib = action.payload;
    },

    setComponentDeployedHosts: (state, action) => {
      state.deployedHosts = action.payload;
    },

    setOperate: (state, action) => {
      state.operate = action.payload;
    },

    resetComponent: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchComponentBasicInfo.pending, (state) => {
        state.basicInfo = {};
      })
      .addCase(fetchComponentBasicInfo.fulfilled, (state, action) => {
        state.basicInfo = action.payload;
      })
      .addCase(fetchComponentVariables.fulfilled, (state, action) => {
        const { componentVariableList } = action.payload;
        const { currentHosts } = state;

        const variables = componentVariableList.map((item) => {
          // 标记选中;
          const tagSelect = item.variableType === 0 || item.notEqual;
          return {
            ...item,
            inputProps: convertDetailToProps(item.showDetail),
            host: currentHosts.find((host) => host.id === item.hostId),
            id: uniqueId(), // 重新生成唯一id
            tagSelect,
            canDelete: !tagSelect, // 是否允许手动删除
            originValue: item.defaultValue, // 备份默认值，方便删除时恢复,拿最新
            scriptStencilVariableId: item.variableId, // 字段转换
          };
        });
        // 组件包级别;
        state.currentVariables = variables.filter((item) => item.variableLevel === 0);

        // ip级别;
        state.currentIpVariables = variables.filter((item) => item.variableLevel === 1);
      });
  },
});

export const {
  resetComponent,
  setCurrentEnv,
  setCurrentCluster,
  setComponentCurrentHosts,
  setComponentCurrentLib,
  modifyHosts,
  removeComponentHost,
  setComponentVariables,
  removeComponentVariables,
  setComponentIpVariables,
  removeComponentIpVariables,
  setComponentDeployedHosts,
  setOperate,
} = execComponentSlice.actions;
export default execComponentSlice.reducer;
